import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from "tss-react/mui";
import EventButton from 'components/EventButton';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import DialogTitle from '@mui/material/DialogTitle';
import InputLabel from '@mui/material/InputLabel';
import Input from '@mui/material/Input';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import PrimaryDialogButton from 'components/PrimaryDialogButton';
import SecondaryDialogButton from 'components/SecondaryDialogButton';
import classNames from 'classnames';
import styles from './styles';
import m from 'messages';

class DurationPicker extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            dialogOpen: false,
            hours: props.hours || 0,
            minutes: props.minutes || 0,
            dialogHours: props.hours || 0,
            dialogMinutes: props.minutes || 0
        };
    }

    handleHourChange = (event) => {
        this.setState({ dialogHours: Number(event.currentTarget.value) });
    };

    handleMinutesChange = (event) => {
        this.setState({ dialogMinutes: Number(event.currentTarget.value) });
    };

    onAccept = () => {
        this.props.onChange(this.state.dialogHours, this.state.dialogMinutes);
        this.setState({
            dialogOpen: false,
            hours: this.state.dialogHours,
            minutes: this.state.dialogMinutes
        });
    };

    onCancel = () => {
        this.setState({ dialogOpen: false });
    };

    render() {
        const { dialogOpen, hours, dialogHours, minutes, dialogMinutes } = this.state;
        const { classes, promptTitle } = this.props;

        return (
            <React.Fragment>
                <Dialog open={dialogOpen} onClose={this.onCancel}>
                    <DialogTitle>{promptTitle}</DialogTitle>
                    <DialogContent>
                        <form className={classes.container}>
                            <FormControl variant="standard" className={classes.formControl}>
                                <InputLabel htmlFor="hours">
                                    {m.general.hours}
                                </InputLabel>
                                <Select
                                    variant="standard"
                                    native
                                    value={dialogHours}
                                    onChange={this.handleHourChange}
                                    input={<Input id="hours" type="number" />}>
                                    <option value="" />
                                    {[0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12].map(n =>
                                        <option value={n} key={n}>{n}</option>
                                    )}
                                </Select>
                            </FormControl>

                            <FormControl variant="standard" className={classes.formControl}>
                                <InputLabel htmlFor="minutes">
                                    {m.general.minutes}
                                </InputLabel>
                                <Select
                                    variant="standard"
                                    native
                                    value={dialogMinutes}
                                    onChange={this.handleMinutesChange}
                                    input={<Input id="minutes" type="number" />}>
                                    <option value="" />
                                    {[0, 15, 30, 45].map(n =>
                                        <option value={n} key={n}>{n}</option>
                                    )}
                                </Select>
                            </FormControl>
                        </form>
                    </DialogContent>
                    <DialogActions className={classes.actions}>
                        <SecondaryDialogButton onClick={this.onCancel}>{m.general.cancel}</SecondaryDialogButton>
                        <PrimaryDialogButton onClick={this.onAccept}>{m.general.ok}</PrimaryDialogButton>
                    </DialogActions>
                </Dialog>

                <div className={classes.container}>
                    <div className={classNames(classes.formControl, classes.formLabel)}>
                        {hours.toString()}h {minutes.toString()}m
                    </div>
                    <div className={classes.formControl}>
                        <EventButton variant="outlined" color="primary" onClick={() => this.setState({ dialogOpen: true })}>
                            {m.general.update}
                        </EventButton>
                    </div>
                </div>
            </React.Fragment>
        );
    }
}

DurationPicker.propTypes = {
    promptTitle: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
    hours: PropTypes.number,
    minutes: PropTypes.number
};

export default withStyles(DurationPicker,styles);
